import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import NewTour from "components/Tour/NewTour";

import { getIsOpen, getStep, updateIsOpen, updateStep } from "containers/Tour/reducer";
import { updateType } from "containers/View/reducer";

class TourContainer extends React.PureComponent {
  render() {
    return <NewTour {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateIsOpen: (isOpen) => dispatch(updateIsOpen(isOpen)),
    updateStep: (step) => dispatch(updateStep(step)),
    updateType: (type) => dispatch(updateType(type))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: getIsOpen(state),
    step: getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TourContainer);
